const AIRPORT_SLUGS = new Set(['ahmedabad-airport-taxi', 'hirasar-to-rajkot-taxi']);
const VEHICLE_SLUGS = new Set(['tempo-traveller-rental-gujarat']);

const FARE_SLUGS_BY_ROUTE = {
  'ahmedabad-airport-taxi': ['sedan', 'ertiga', 'innova_crysta', 'suv'],
  'tempo-traveller-rental-gujarat': ['tempo_traveller', 'innova_crysta', 'ertiga'],
};

function derivePageType(slug) {
  if (VEHICLE_SLUGS.has(slug)) return 'vehicle';
  if (AIRPORT_SLUGS.has(slug)) return 'airport';
  return 'route';
}

function deriveInitialTripType(pageType) {
  if (pageType === 'airport') return 'airport_transfer';
  return 'one_way';
}

function deriveLeadSource(row) {
  if (row.from_city && row.to_city) {
    return `SEO Route - ${row.from_city} to ${row.to_city}`;
  }
  if (row.h1) return `SEO Route - ${row.h1.replace(/\s*Taxi Service$/i, '').trim()}`;
  return `SEO Route - ${row.slug}`;
}

/** Map Supabase route_pages row → frontend route object (static routePages.js shape). */
export function normalizeRoutePage(row) {
  if (!row) return null;

  const pageType = derivePageType(row.slug);
  const flatFares = Array.isArray(row.flat_fares) ? row.flat_fares : [];

  return {
    id: row.id,
    slug: row.slug,
    fromCity: row.from_city || '',
    toCity: row.to_city || null,
    title: row.title,
    metaDescription: row.meta_description,
    h1: row.h1,
    introText: row.intro_text,
    approxDistanceKm: row.approx_distance_km ?? null,
    approxDuration: row.approx_duration || '',
    imageUrl: row.image_url || null,
    flatFares,
    faqs: Array.isArray(row.faqs) ? row.faqs : [],
    isActive: row.is_active !== false,
    sortOrder: row.sort_order ?? 0,
    pageType,
    initialTripType: deriveInitialTripType(pageType),
    leadSource: deriveLeadSource(row),
    fareSlugs: FARE_SLUGS_BY_ROUTE[row.slug],
  };
}

export function routePageToDbPayload(form, imageUrl) {
  const flatFares = (form.flat_fares || [])
    .filter((t) => t.vehicle?.trim() && t.amount !== '' && t.amount != null)
    .map((t) => ({
      vehicle: t.vehicle.trim(),
      amount: Number(t.amount),
    }));

  const faqs = (form.faqs || [])
    .filter((f) => f.question?.trim() && f.answer?.trim())
    .map((f) => ({
      question: f.question.trim(),
      answer: f.answer.trim(),
    }));

  return {
    slug: form.slug.trim(),
    from_city: form.from_city?.trim() || null,
    to_city: form.to_city?.trim() || null,
    title: form.title.trim(),
    meta_description: form.meta_description.trim(),
    h1: form.h1.trim(),
    intro_text: form.intro_text.trim(),
    approx_distance_km:
      form.approx_distance_km === '' || form.approx_distance_km == null
        ? null
        : Number(form.approx_distance_km),
    approx_duration: form.approx_duration?.trim() || null,
    image_url: imageUrl || form.image_url || null,
    flat_fares: flatFares,
    faqs,
    is_active: form.is_active !== false,
    sort_order: Number(form.sort_order) || 0,
    updated_at: new Date().toISOString(),
  };
}
